module.exports = __webpack_public_path__ + "static/img/Reuben-Cotter.b4e3c62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Reuben-Cotter.jpg
// module id = 050Q
// module chunks = 0